import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-mobile-sitemap-menu',
  templateUrl: './mobile-sitemap-menu.component.html'
})
export class MobileSitemapMenuComponent {
  @Input() item
  @Input() menus
  @Input() index
  @Output() page = new EventEmitter()

}
